import {
  Component,
  OnInit,
  Input,
  ElementRef,
  Output,
  EventEmitter
} from '@angular/core';
import domtoimage from 'dom-to-image';

@Component({
  selector: 'nz-dom2img-net',
  preserveWhitespaces: false,
  templateUrl: './dom2img-net.component.html'
})
export class NzDom2ImgNetComponent implements OnInit {
  @Input('eventTigger') eventTigger: string = 'click';
  @Input('options') options: {
    type: string,
    selector: string,
    download?: boolean,
    quality?: number,
    imgName?: string
  };
  @Output('getImg') getImg: EventEmitter<any> = new EventEmitter;
  fileReader = new FileReader();
  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.options = {
      type: 'png',
      selector: '#demo',
      quality: 0.95,
      download: true,
      imgName: 'img',
      ...this.options
    }
    this.el.nativeElement.addEventListener(this.eventTigger, () => {
      this.domToImg();
    })
  }

  domToImg(): any {
    if (!this.options.type) { return }
    if (this.options.type === 'png') {
      return this.toPng();
    } else if (this.options.type === 'jpg') {
      return this.toJpg();
    } else if (this.options.type === 'blob') {
      return this.toBlob();
    } else if (this.options.type === 'svg') {
      return this.toSvg();
    }
  }
  toPng() {
    domtoimage.toPng(this.el.nativeElement.querySelector(this.options.selector))
      .then((dataUrl) => {
        if (this.options.download) {
          const link = document.createElement('a');
          link.download = `${this.options.imgName}.png`;
          link.href = dataUrl;
          link.click();
        }
        this.getImg.emit(dataUrl);
      });
  }
  toBlob() {
    domtoimage.toBlob(this.el.nativeElement.querySelector(this.options.selector))
      .then((blob) => {
        this.SAVEAS({ blob, name: `${this.options.imgName}.png`});
      });
  }

  toJpg() {
    domtoimage.toJpeg(this.el.nativeElement.querySelector(this.options.selector), { quality: this.options.quality || 0.95 })
      .then((dataUrl) => {
        if (this.options.download) {
          const link = document.createElement('a');
          link.download = `${this.options.imgName}.jpeg`;
          link.href = dataUrl;
          link.click();
        }
        this.getImg.emit(dataUrl);
      });
  }

  toSvg() {
    domtoimage.toSvg(this.el.nativeElement.querySelector(this.options.selector), { filter: node => node.tagName !== 'i' })
    .then((dataUrl) => {
      if (this.options.download) {
        const link = document.createElement('a');
        link.download = `${this.options.imgName}.svg`;
        link.href = dataUrl;
        link.click();
      }
      this.getImg.emit(dataUrl);
    });
  }

  SAVEAS(options): void {
    let _global = (function () {
      // some use content security policy to disable eval
      try {
        return Function('return this')() || (42, eval)('this')
      } catch (e) {
        // every global should have circular reference
        // used for checking if someone writes var window = {}; var self = {}
        return typeof window === 'object' && window.window === window ? window
          : typeof self === 'object' && self.self === self ? self
            : typeof global === 'object' && global.global === global ? global : this
      }
    })()

    function bom(blob, opts) {
      if (typeof opts === 'undefined') opts = { autoBom: false }
      else if (typeof opts !== 'object') {
        console.warn('Depricated: Expected third argument to be a object')
        opts = { autoBom: !opts }
      }

      // prepend BOM for UTF-8 XML and text/* types (including HTML)
      // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
      if (opts.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type })
      }
      return blob
    }

    function download(url, name, opts) {
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        saveAs({ blob: xhr.response, name, opts })
      }
      xhr.onerror = function () {
        console.error('could not download file')
      }
      xhr.send()
    }

    function corsEnabled(url) {
      let xhr = new XMLHttpRequest()
      // use sync to avoid popup blocker
      xhr.open('HEAD', url, false)
      xhr.send()
      return xhr.status >= 200 && xhr.status <= 299
    }

    // `a.click()` doesn't work for all browsers (#465)
    function click({ node, type = '' }) {
      try {
        node.dispatchEvent(new MouseEvent('click'))
      } catch (e) {
        let evt = document.createEvent('MouseEvents')
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80,
          20, false, false, false, false, 0, null)
        node.dispatchEvent(evt)
      }
    }

    let saveAs = _global.saveAs ||
      // probably in some web worker
      (typeof window !== 'object' || window !== _global)
      ? function saveAs() { /* noop */ }

      // Use download attribute first if possible (#193 Lumia mobile)
      : 'download' in HTMLAnchorElement.prototype
        ? function saveAs({ blob, name, opts }) {
          let URL = _global.URL || _global.webkitURL
          let a = document.createElement('a')
          name = name || blob.name || 'download'

          a.download = name
          a.rel = 'noopener' // tabnabbing

          // TODO: detect chrome extensions & packaged apps
          // a.target = '_blank'

          if (typeof blob === 'string') {
            // Support regular links
            a.href = blob
            if (a.origin !== location.origin) {
              corsEnabled(a.href)
                ? download(blob, name, opts)
                : click({ node: a, type: '_blank' })
            } else {
              click({ node: a })
            }
          } else {
            // Support blobs
            a.href = URL.createObjectURL(blob)
            setTimeout(function () { URL.revokeObjectURL(a.href) }, 4E4) // 40s
            setTimeout(function () { click({ node: a }) }, 0)
          }
        }

        // Use msSaveOrOpenBlob as a second approach
        : 'msSaveOrOpenBlob' in navigator
          ? function saveAs({ blob, name, opts }) {
            name = name || blob.name || 'download'

            if (typeof blob === 'string') {
              if (corsEnabled(blob)) {
                download(blob, name, opts)
              } else {
                let a = document.createElement('a')
                a.href = blob
                a.target = '_blank'
                setTimeout(function () { click({ node: a }) })
              }
            } else {
              navigator.msSaveOrOpenBlob(bom(blob, opts), name)
            }
          }

          // Fallback to using FileReader and a popup
          : function saveAs({ blob, name, opts, popup }) {
            // Open a popup immediately do go around popup blocker
            // Mostly only avalible on user interaction and the fileReader is async so...
            popup = popup || open('', '_blank')
            if (popup) {
              popup.document.title =
                popup.document.body.innerText = 'downloading...'
            }

            if (typeof blob === 'string') return download(blob, name, opts)

            let force = blob.type === 'application/octet-stream'
            let isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
            let isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)

            if ((isChromeIOS || (force && isSafari)) && typeof FileReader === 'object') {
              // Safari doesn't allow downloading of blob urls
              let reader = this.fileReader
              reader.onloadend = function () {
                let url = reader.result
                url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;')
                if (popup) popup.location.href = url
                else location = url
                popup = null // reverse-tabnabbing #460
              }
              reader.readAsDataURL(blob)
            } else {
              let URL = _global.URL || _global.webkitURL
              let url = URL.createObjectURL(blob)
              if (popup) popup.location = url
              else location.href = url
              popup = null // reverse-tabnabbing #460
              setTimeout(function () { URL.revokeObjectURL(url) }, 4E4) // 40s
            }
          }
    saveAs(options);
  }
}